import React from 'react'

import {
  Box,
  Text,
} from '@usap/uicomponents'

import Actions from './Actions'
import Items from './Items'
import WarningMedium from '../../../Notification/Types/WarningMedium'
import useWmoEnabled from '../../../../../../hooks/useWmoEnabled'
import PopUpBox from '../../PopUpBox'
import OutOfStockItemsWmo from './OutOfStockItemsWmo'

const OutOfStockItems = params => {
  const { data, showOosProducts, shouldShowOosProducts } = params

  const message = `Sorry, one or more items in your cart are out of stock. Remove these items
      to proceed to checkout`

  const style = {
    wrapperHeight: { min: '500px' },
    oosWrapperPad: { bottom: 'small' },
  }

  const isWmoEnabled = useWmoEnabled()
  if (isWmoEnabled) {
    return (
      <OutOfStockItemsWmo
        data={data}
        showOosProducts={showOosProducts}
        shouldShowOosProducts={shouldShowOosProducts}
      />
    )
  }

  return (
    <PopUpBox
      showPopup={showOosProducts}
      shouldShowPopup={shouldShowOosProducts}
    >
      <Box pad="medium" height={style.wrapperHeight} width="700px">
        <WarningMedium message={message} />
        <Box width="100%" pad={style.oosWrapperPad}>
          <Text size="small" color="dark-2" weight="bold">
            Out Of Stock Items
          </Text>
        </Box>

        <Items data={data} />
        <Actions data={data} />
      </Box>
    </PopUpBox>
  )
}

export default OutOfStockItems
